<!--安装订单上传安装图片页-->
<template>
    <div id="that">
        <div style="margin-left: 20px;text-align: center;padding: 10px;padding-bottom: 50px;">

            <div>
                <van-uploader deletable capture v-model="fileList1" :after-read="onPic" :before-delete="deletePic2"
                              ref="uploader">
                    <div></div>
                </van-uploader>
            </div>
            <div>
                <van-button type="info" style="margin-right: 5px;" @click="onPic(1)">现场拍摄
                </van-button>
            </div>

            <div v-if="positioningDeviceModel">
                <van-divider/>

                <van-uploader multiple show-upload="true" v-model="fileList2" :after-read="afterRead"
                              :before-delete="deletePic2" ref="uploader">
                    <div></div>
                </van-uploader>
                <div>
                    <van-button type="info" style="margin-right: 5px;" @click="onPic(2)">运维图片
                    </van-button>
                </div>
            </div>

        </div>
        <van-overlay :show="showOverlay" @click="showOverlay = false">
            <!--            <van-loading size="90" style="padding-top: 200px" color="#1989fa;"/>-->
            <van-circle
                    v-model:current-rate="currentRate"
                    :rate="rate"
                    :speed="200"
                    :stroke-width="120"
                    style="padding-top: 200%"
            >

            </van-circle>
        </van-overlay>
        <!--        <van-button type="info" style="margin-right: 5px;" @click="onPic">选择图片-->
        <!--        </van-button>-->
        <!--        <van-button type="info" @click="restart">刷新-->
        <!--        </van-button>-->

    </div>
</template>
<script>
    import Vue from 'vue'
    import store from '@/store'
    import axios from 'axios'

    const wx = require('weixin-js-sdk')
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        Uploader,
        Overlay,
        Circle,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Circle)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

    export default {
        inject: ['reload'],
        name: "uploaderinstallorderinstallimage",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null
        },
        data() {
            return {
                showOverlay: false,
                currentRate: 0,
                rate: 0,

                positioningDeviceModel: true,

                columns: [
                    {
                        title: 'picKey',
                        key: 'picKey',
                        ellipsis: 'true',
                        minWidth: 250,
                    },
                ],

                PicId: null,

                // loadingStatus: false,

                addPictureRecord: {
                    picKey: null,
                    srcHeight: null,
                    srcWidth: null,
                    picType: 1
                },
                postParams: {
                    upload_token: null,
                    picKey: null
                },
                uploadFile: [],
                pictureRecords: [],

                fileList1: [],
                fileList2: [],
            }
        },
        methods: {
            restart() {
                this.fileList1 = []
                this.fileList2 = []
                this.loadPhotoRecords();
                // this.reload();
            },
            onPic(e) {
                console.log(e)
                var appid = 'wx35df9038a4f73847'
                var noncestr = 'UploaderInstallOrderImage' + Date.parse(new Date()) / 1000
                var timestamp = Date.parse(new Date()) / 1000
                // let url = location.href.split('#')[0]
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                let url = ''
                if (isAndroid) {
                    url = location.href
                }
                Vue.prototype.href = window.location.href
                if (isIOS) {
                    url = window.location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
                }
                store.dispatch('MediaPlatformServ_GetSignature', {
                    urlparams: {
                        noncestr: noncestr,
                        timestamp: timestamp,
                        url: url,
                    }
                }).then(res => {
                    console.log(res)
                    // alert(res.data)
                    wx.config({
                        debug: false,
                        appId: appid,
                        timestamp: timestamp,
                        nonceStr: noncestr,
                        signature: res.data,
                        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
                            'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getLocalImgData', 'checkJsApi','createCameraContext'],
                        success: function (res) {
                            console.log(res)
                        },
                        fail: function (err) {
                            console.log(err)
                        }
                    });
                }).catch(err => {
                    console.log(err)
                })

                wx.checkJsApi({
                    jsApiList: ['getLocalImgData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function (res) {
                        // 以键值对的形式返回，可用的api值true，不可用为false
                        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                        console.log(res)
                    }
                });

                let that = this
                if (e == 1) {
                    wx.ready(function () {
                        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                        wx.chooseImage({
                            count: 9, // 默认9
                            sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                            sourceType: ['camera','album'], // 可以指定来源是相册还是相机，默认二者都有
                            isShowProcess: 1,
                            success: function (res) {
                                console.log(res)
                                console.log(res.localIds.length)
                                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                                for (let i = 0; i <= res.localIds.length - 1; i++) {
                                    console.log(i)
                                    setTimeout(function timer() {
                                        that.text(res.localIds[i], e, res.localIds.length, i);
                                        that.fileList1 = []
                                        that.fileList2 = []
                                        // that.reload();
                                    }, i * 500);
                                }
                                // that.loadPhotoRecords();
                            },
                            fail: function (err) {
                                console.log(err)
                            }
                        });

                    });
                } else {

                    wx.ready(function () {
                        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                        wx.chooseImage({
                            count: 9, // 默认9
                            sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                            sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
                            isShowProcess: 1,
                            success: function (res) {
                                console.log(res)
                                console.log(res.localIds.length)
                                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                                for (let i = 0; i <= res.localIds.length - 1; i++) {
                                    console.log(i)
                                    setTimeout(function timer() {
                                        that.text(res.localIds[i], e, res.localIds.length, i);
                                        that.fileList1 = []
                                        that.fileList2 = []
                                        // that.reload();
                                        // if (i==(res.localIds.length-1)) {
                                        //     that.loadPhotoRecords();
                                        // }
                                    }, i * 500);
                                }
                            },
                            fail: function (err) {
                                console.log(err)
                            }
                        });

                    });

                }
                wx.error(function (res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    console.log(res)
                });


            },


            text(localIds, e, length, i) {
                this.showOverlay = true
                console.log(localIds)
                console.log(e)
                let that = this
                wx.getLocalImgData({
                    localId: localIds,
                    success: function (res) {
                        console.log('预览图片成功')
                        const localData = res.localData;
                        let imageBase64 = '';
                        console.log('转换成base64')
                        if (localData.indexOf('data:image') == 0) {
                            //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                            imageBase64 = localData;
                            console.log(imageBase64)
                        } else {
                            //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                            //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                            imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                            console.log(imageBase64)
                        }
                        console.log('base64转换成二进制')
                        let dataurltoblob = dataURLtoBlob(imageBase64)
                        console.log(dataurltoblob)

                        //获取七牛上传凭证
                        store.dispatch('PictureServ_GetQiniuUploadToken', {
                            params: {
                                head: 'INSTALLORDER'
                            },
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                            let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                            handleAvatar(dataurltoblob, uploadToken, photoKey, e, length, i)
                        }).catch((err) => {
                            console.log(err)
                            this.errorlog('七牛错误' + err)
                        })

                        /**
                         * base64转为可post的二进制数据
                         */
                        function dataURLtoBlob(dataurl) {
                            let arr = dataurl.split(',');
                            let mime = arr[0].match(/:(.*?);/)[1];
                            let bstr = atob(arr[1]);
                            let n = bstr.length;
                            let u8arr = new Uint8Array(n);
                            while (n--) {
                                u8arr[n] = bstr.charCodeAt(n);
                            }
                            return new Blob([u8arr], {
                                type: mime
                            });
                        }

                        /**
                         * ajax上传图片
                         */
                        function handleAvatar(imageBase64, uploadToken, photoKey, e, length, i) {
                            console.log(imageBase64)
                            console.log(uploadToken)
                            console.log(photoKey)
                            var param = new FormData();
                            // param.append('headPic', imageBase64);
                            param.append('file', imageBase64);
                            param.append('chunk', '0');//断点传输
                            param.append('chunks', '1');
                            param.append('token', uploadToken)
                            param.append('key', photoKey);
                            let config = {
                                // headers:{'X-Requested-with':'XMLHttpRequest'},
                                // headers:{'Content-Type':'application/json'},
                                headers: {'Content-Type': 'multipart/form-data'},
                                // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                                withCredentials: false
                            };

                            let installOrderPicture = {
                                id: null,
                                picKey: null,
                                picType: null,
                                srcWidth: null,
                                srcHeight: null,
                                upload_token: null,
                                picKey: null,
                            }
                            installOrderPicture.id = that._initValue
                            installOrderPicture.picType = e.toString()
                            installOrderPicture.srcWidth = imageBase64.srcWidth
                            installOrderPicture.srcHeight = imageBase64.srcHeight
                            installOrderPicture.upload_token = uploadToken
                            installOrderPicture.picKey = photoKey

                            axios.post('https://upload-z2.qiniup.com', param, config)
                                .then(response => {
                                    console.log(response);
                                    console.log(response.data);
                                    // alert(response)
                                    // alert('上传七牛成功')
                                    // this.addPictureRecord.picKey = this.MaintainPicture.picKey

                                    // console.log(this.addPictureRecord)
                                    //  未完成的订单
                                    //安装订单更换图片
                                    store.dispatch('InstallOrderServ_UploadInstallorderePicture', {
                                        params:
                                        installOrderPicture
                                        ,
                                        urlparams: null
                                    }).then((res) => {
                                        console.log(res)
                                        // this.loadingStatus = false
                                        // this.loadingStatusafter = false
                                        // Toast.success('添加图片成功')
                                        that.schedule(length, i)
                                        /**
                                         * 异步调用导致列表长度不对，无法正常点击table打开图片
                                         */
                                        // this.loadPhotoRecords(this.maintainOrderid)
                                    }).catch(err => {
                                        // this.loadingStatus = false
                                        Toast(err)
                                        console.log(err)
                                    });
                                }).catch(err1 => {

                                Toast(err1)
                                // this.loadingStatus = false
                            })


                        };
                    },
                    fail: function (err) {
                        console.log(err)
                    },
                    complete: function (res) {
                        console.log(res)
                    }
                });
            },

            deletePic2(file, e) {
                console.log(e)
                console.log(file)
                this.$Modal.confirm({
                    title: '确认删除',
                    content: '<p>确认删除</p>',
                    onOk: () => {
                        store.dispatch('InstallOrderServ_RemoveInstallorderePicture', {
                            params: {installorderpictureId: file.id}
                        }).then(() => {
                            this.$Message.success('删除成功')
                            this.fileList1 = []
                            this.fileList2 = []
                            this.loadPhotoRecords()
                            // this.reload()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            afterRead(file, e) {
                this.showOverlay = true
                // Toast('开始')
                this.show = true
                console.log(e)
                console.log(file)
                this.addPictureRecord.picType = e.name
                if (file.length > 1) {

                    file.forEach((item, index) => {
                        //获取七牛上传凭证
                        store.dispatch('PictureServ_GetQiniuUploadToken', {
                            params: {
                                head: 'INSTALLORDER' + index
                            },
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                            let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                            // that.uploadFile.push({item,uploadToken,photoKey})
                            this.vanupload(item.file, uploadToken, photoKey)
                            if (index == (file.length - 1)) {
                                this.showOverlay = false
                                this.fileList1 = []
                                this.fileList2 = []
                                this.loadPhotoRecords()
                                // this.reload()
                            }
                        }).catch((err) => {
                            console.log(err)
                            this.errorlog('七牛错误' + err)
                        })
                    })
                } else {
                    //获取七牛上传凭证
                    store.dispatch('PictureServ_GetQiniuUploadToken', {
                        params: {
                            head: 'INSTALLORDER'
                        },
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                        let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                        // that.uploadFile.push({item,uploadToken,photoKey})
                        this.vanupload(file.file, uploadToken, photoKey)
                        this.fileList1 = []
                        this.fileList2 = []
                        this.loadPhotoRecords()
                        this.showOverlay = false
                        // this.reload()
                    }).catch((err) => {
                        console.log(err)
                        this.errorlog('七牛错误' + err)
                    })
                }
            },
            vanupload(file, uploadToken, photoKey) {
                let param = new FormData(); //创建form对象
                param.append('chunk', '0');//断点传输
                param.append('chunks', '1');
                param.append('token', uploadToken)
                param.append('key', photoKey);
                param.append('file', file, file.name)
                let config = {
                    // headers:{'X-Requested-with':'XMLHttpRequest'},
                    // headers:{'Content-Type':'application/json'},
                    headers: {'Content-Type': 'multipart/form-data'},
                    // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                    withCredentials: false
                };
                this.loadingStatus = true;

                let installOrderPicture = {
                    id: null,
                    picKey: null,
                    picType: null,
                    srcWidth: null,
                    srcHeight: null,
                    upload_token: null,
                    picKey: null,
                }
                installOrderPicture.id = this._initValue
                installOrderPicture.picType = file.picType
                installOrderPicture.srcWidth = file.srcWidth
                installOrderPicture.srcHeight = file.srcHeight
                installOrderPicture.upload_token = uploadToken
                installOrderPicture.picKey = photoKey


                axios.post('https://upload-z2.qiniup.com', param, config)
                    .then(response => {
                        console.log(response);
                        console.log(response.data);
                        // this.addPictureRecord.picKey = this.MaintainPicture.picKey

                        // console.log(this.addPictureRecord)
                        //  未完成的订单
                        //安装订单更换图片
                        store.dispatch('InstallOrderServ_UploadInstallorderePicture', {
                            params:
                            installOrderPicture
                            ,
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            this.loadingStatus = false
                            this.loadingStatusafter = false
                            Toast.success('添加图片成功')
                            this.uploadFile = null

                            /**
                             * 异步调用导致列表长度不对，无法正常点击table打开图片
                             */
                            // this.loadPhotoRecords(this.maintainOrderid)
                            this.fileList1 = []
                            this.fileList2 = []
                            this.loadPhotoRecords()
                        }).catch(err => {
                            this.loadingStatus = false
                            Toast(err)
                            console.log(err)
                        });
                    }).catch(err1 => {

                    Toast(err1)
                    console.log(err)
                    this.loadingStatus = false
                })
            },
            // 图片上传进度
            schedule(length, i) {
                length = length - 1
                this.rate = ((i+1)/length)*100
                if (length === i) {
                    this.showOverlay = false
                    this.loadPhotoRecords()
                }
            },
            loadPhotoRecords() {
                console.log(new Date())
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: this._initValue},
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    let title = null
                    let installOrder = store.getters.get_InstallOrder_GetDetailResult
                    this.installOrder = installOrder

                    // if (this.installOrder.positioningDeviceInfos!=null && this.installOrder.positioningDeviceInfos.length>0) {
                    //     this.installOrder.positioningDeviceInfos.forEach(item => {
                    //         if (item.positioningDeviceModel.adas) {
                    //             this.positioningDeviceModel = true
                    //         }
                    //     })
                    // }

                    this.pictureRecords = this.installOrder.installOrderPics
                    this.installOrder.installOrderPics.forEach(item => {
                        if (item.picType == 1) {

                            this.fileList1.push({
                                id: item.id,
                                url: 'https://pic.jianchengjt.com/' + item.picKey + '?imageView2',
                                isImage: true
                            })
                        } else {

                            this.fileList2.push({
                                id: item.id,
                                url: 'https://pic.jianchengjt.com/' + item.picKey + '?imageView2',
                                isImage: true
                            })
                        }
                    })
                }).catch(err => {
                    console.log('123')
                    this.$Message.error(err)
                })
            },
            success() {
                this.$Message.success('This is a success tip');
                store.dispatch('InstallOrderServ_ConfirmUpload', {
                    params: {
                        id: null,
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                }).catch((err) => {
                    console.log(err)
                })
            },
            warning() {
                this.$Message.warning('This is a warning tip');
            },
            error() {
                this.$Message.error('This is an error tip');
            },
            onFind() {
                this.success()
            },

        },
        computed: {
            _value: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            this.loadPhotoRecords()
        }
    }
</script>
<style>
    .father:hover .element {
        display: block;
    }

    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    #that {
        height: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
</style>
